import { render, staticRenderFns } from "./OIcon.vue?vue&type=template&id=3e6d184e&"
import script from "./OIcon.vue?vue&type=script&lang=js&"
export * from "./OIcon.vue?vue&type=script&lang=js&"
import style0 from "./OIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports